<h1 mat-dialog-title>{{ 'DIALOGS.ERROR' | translate }}</h1>
<mat-dialog-content>
  {{ data?.message ?? ('DIALOGS.OFFLINE' | translate) }}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="RETRY_RESULTS.CANCEL">
    {{ 'DIALOGS.CANCEL' | translate }}
  </button>
  <button mat-button [mat-dialog-close]="RETRY_RESULTS.RETRY">{{ 'DIALOGS.RETRY' | translate }}</button>
  <button mat-button [mat-dialog-close]="RETRY_RESULTS.STORE_OFFLINE">
    {{ 'DIALOGS.STORE_OFFLINE' | translate }}
  </button>
</mat-dialog-actions>
